import {
  FINALIZE_SSO_URL_PARAM,
  FORCE_DISABLE_URL_PARAM,
  FORCE_DISABLE_COOKIE_NAME,
  FORCE_DISABLE_COOKIE_EXPIRY,
} from '../constants';
import Cookie from '@wetransfer/transfer/modules/concorde-cookie';

export const handleForceDisableCookie = (): void => {
  if (window.location.search.includes(`${FORCE_DISABLE_URL_PARAM}=true`)) {
    const expires = new Date(Date.now() + FORCE_DISABLE_COOKIE_EXPIRY);
    Cookie.set(FORCE_DISABLE_COOKIE_NAME, 'true', { expires });
  }

  if (window.location.search.includes(`${FORCE_DISABLE_URL_PARAM}=false`)) {
    Cookie.unset(FORCE_DISABLE_COOKIE_NAME);
  }
};

export const checkIfSSOIsEnabled = (): boolean => {
  // When the cookie has a value of true, force disable
  // the SSO behavior.
  if (document.cookie.includes(`${FORCE_DISABLE_COOKIE_NAME}=true`)) {
    return false;
  }

  return true;
};

export const returnedFromSSO = (): boolean => {
  return (
    checkIfSSOIsEnabled() &&
    window &&
    window.location &&
    (window.location.search.includes(FINALIZE_SSO_URL_PARAM) ||
      window.location.pathname.includes('/account/callback'))
  );
};
